// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton-module__main--nJBeE {
    outline: none;
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    box-sizing: border-box;
    padding: 0px;
}

.IconButton-module__main--nJBeE img {
    width: 24px;
    height: 24px;
}

.IconButton-module__outline--weVCh {
    border: 1px solid var(--color-general-black);
    border-radius: 12px;
}

.IconButton-module__outline--weVCh.IconButton-module__small--zXPTQ {
    padding: 9px;
}

.IconButton-module__outline--weVCh.IconButton-module__medium--QRMzu {
    padding: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/IconButton/IconButton.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".main {\n    outline: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    box-sizing: border-box;\n    padding: 0px;\n}\n\n.main img {\n    width: 24px;\n    height: 24px;\n}\n\n.outline {\n    border: 1px solid var(--color-general-black);\n    border-radius: 12px;\n}\n\n.outline.small {\n    padding: 9px;\n}\n\n.outline.medium {\n    padding: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `IconButton-module__main--nJBeE`,
	"outline": `IconButton-module__outline--weVCh`,
	"small": `IconButton-module__small--zXPTQ`,
	"medium": `IconButton-module__medium--QRMzu`
};
export default ___CSS_LOADER_EXPORT___;
